import { SignatureOutlined } from '@ant-design/icons'
import { Button, Form, Modal, Space, Tooltip, Typography } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import dayjs from 'dayjs'
import { useState } from 'react'
import { useFormEditor } from '../../contexts/FormContext'
import { CampaignEmployee } from '../../models/Campaign'
import Signature from '../Signature'

const { Text } = Typography

interface Props {
  campaignEmployee?: CampaignEmployee
  isEmployee?: boolean
}

export const SignSummary = ({
  campaignEmployee: campaignEmployeeProps,
  isEmployee: isEmployeeProps,
}: Props) => {
  const {
    campaignEmployee: campaignEmployeeFormEditor,
    isEmployee: isEmployeePropsFormEditor,
  } = useFormEditor()

  const campaignEmployee = campaignEmployeeProps
    ? campaignEmployeeProps
    : campaignEmployeeFormEditor

  const isEmployee = isEmployeeProps
    ? isEmployeeProps
    : isEmployeePropsFormEditor

  if (campaignEmployee === undefined || isEmployee === undefined) return <></>

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  return (
    <>
      <Button
        type="primary"
        icon={<SignatureOutlined />}
        onClick={() => setIsModalOpen(true)}
      >
        Résumé
      </Button>
      <Modal
        title="Résumé de l'entretien"
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        okText={'Fermer'}
        onCancel={() => setIsModalOpen(false)}
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <Form layout="vertical">
          {/* EMPLOYEE */}
          <Form.Item
            label={`Commentaire de ${campaignEmployee.employee?.firstName} ${campaignEmployee.employee?.lastName}`}
          >
            <TextArea
              rows={5}
              disabled
              value={campaignEmployee.employeeComment}
            />
          </Form.Item>
          <Space vertical className="w-full" style={{ marginBottom: 30 }}>
            <Text style={{ marginBottom: 15 }}>
              Signé le{' '}
              <Tooltip
                title={dayjs(campaignEmployee.employeeSignedAt).fromNow()}
              >
                {dayjs(campaignEmployee.employeeSignedAt).format(
                  'DD/MM/YYYY à HH:mm:ss'
                )}
              </Tooltip>
            </Text>
            <Signature
              text={`${campaignEmployee.employee?.firstName} ${campaignEmployee.employee?.lastName}`}
            />
          </Space>

          {/* MANAGER */}
          <Form.Item
            label={`Commentaire de ${campaignEmployee.manager?.firstName} ${campaignEmployee.manager?.lastName}`}
          >
            <TextArea
              rows={5}
              disabled
              value={campaignEmployee.managerComment}
            />
          </Form.Item>
          <Space vertical className="w-full" style={{ marginBottom: 30 }}>
            <Text style={{ marginBottom: 15 }}>
              Signé le{' '}
              <Tooltip
                title={dayjs(campaignEmployee.managerSignedAt).fromNow()}
              >
                {dayjs(campaignEmployee.managerSignedAt).format(
                  'DD/MM/YYYY à HH:mm:ss'
                )}
              </Tooltip>
            </Text>
            <Signature
              text={`${campaignEmployee.manager?.firstName} ${campaignEmployee.manager?.lastName}`}
            />
          </Space>
        </Form>
      </Modal>
    </>
  )
}
